<template>
    <div class="archiveFilesTabs">
        <el-tabs v-model="activeName" @tab-click="handleTabClick" :class="'process-design-tabs'">
            <el-tab-pane label="文件列表视图" name="first" :class="'process-design-item'">
                <div class="process-design-item-content">
                    <ProcessFiles v-if="isShowProcessFiles" :bizType="bizType" :taskAssigneeId="taskAssigneeId" :templateId="templateId" :processInstanceId="processInstanceId" :taskId="taskId" :isSubProcess="isSubProcess" :isFullScreen="isFullScreen" :taskInfo="taskInfo" :isCloseFileUpload="isCloseFileUpload" @handleFullScreen="handleFullScreen"/>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="templateId" label="档案目录视图" name="second" :class="'process-design-item'">
                <div class="process-design-item-content">
                    <DocView v-if="isShowFileDocView" :templateId="templateId" :processInstanceId="processInstanceId" :taskInstanceId="taskId" :isSubProcess="isSubProcess" :isFullScreen="isFullScreen" @handleFullScreen="handleFullScreen"/>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="templateId" label="档案列表视图" name="third" :class="'process-design-item'">
                <div class="process-design-item-content">
                    <ArchiveTableView v-if="isShowArchiveTableView"
                    :isFullScreen="isFullScreen"
                    :templateId="templateId"
                    :processInstanceId="processInstanceId"
                    :taskId="taskId"
                    :isSubProcess="isSubProcess"
                    :rootPath="rootPath"
                    :bizType="bizType"
                    :instancesInfo="instancesInfo"
                    @handleFullScreen="handleFullScreen"/>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ProcessFiles from '@/pages/process/components/ProcessFiles';
    import DocView from '@/pages/document/Archive/ArchiveView2/DocView';
    import ArchiveTableView from './ArchiveTableView';
    export default {
        components: {
            ProcessFiles: ProcessFiles,
            DocView: DocView,
            ArchiveTableView: ArchiveTableView
        },
        data () {
            return {
                rootPath: '/document/archive',
                activeName: 'first',
                isShowProcessFiles: false,
                isShowFileDocView: false,
                isShowArchiveTableView: false
            };
        },
        props: {
            taskAssigneeId: {
                type: String,
                default: ''
            },
            bizType: { // 文件上传的类型。 task、process
                type: String
                // default: 'process'
            },
            taskId: {
                type: String
            },
            templateId: { // 档案模板id
                type: String
            },
            processInstanceId: { // 流程实例id
                type: String
            },
            isSubProcess: {
                type: Boolean,
                default: false
            },
            instancesInfo: {
                type: Object
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            },
            taskInfo: {
                type: Object
            },
            isCloseFileUpload: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this.resetShowStatus();
            this.isShowProcessFiles = true;
        },
        methods: {
            handleTabClick (tab, event) {
                // console.log(tab);
                this.resetShowStatus();
                if (tab.index === '0') {
                    this.activeName = 'first';
                    this.isShowProcessFiles = true;
                } else if (tab.index === '1') {
                    this.activeName = 'second';
                    this.isShowFileDocView = true;
                } else if (tab.index === '2') {
                    this.activeName = 'third';
                    this.isShowArchiveTableView = true;
                }
            },
            resetShowStatus () {
                this.isShowProcessFiles = false;
                this.isShowFileDocView = false;
                this.isShowArchiveTableView = false;
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            }
        }
    };
</script>

<style lang="less" scoped>
    .archiveFilesTabs {
        height: 98%;
        width: 99%;
        padding-left: 0.5vw;
        padding-top: 8px;

        @media screen and (min-width: 1024px) and (max-width: 1366px) {
           width: 98%;
        }
        .process-design-tabs{
            height: ~"calc(100% - 2vh)";
            width: 98%;
            border: 1px solid #f2f2f2;
            padding: 0.5vw;
            .process-design-item{
                height: 80vh;
                padding: 0 10px 0 10px;
                @media screen and (min-width: 1024px) and (max-width: 1366px) {
                   height: 70vh;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/components/ArchiveFilesTabs/ArchiveFilesTabs.vue